import React, { useState, useCallback } from 'react';
import * as S from './Home.styles';
import { TabBar } from '@/components/TabBar/TabBar';
import { PageTopControls } from '@/components/PageTopControls';
import { AndroidAppBanner } from '@/components/AndroidAppBanner/AndroidAppBanner';
import { useBanner } from '@/hooks/useBanner';
import { useMobileDetect } from '@/hooks/useMobileDetect';
import { CatalogueGrid } from '@/components/CatalogueGrid/CatalogueGrid';
import { Header } from '@/components/Header';
import { SearchPanel } from '@/components/SearchPanel';
import { useResponsive } from '@/hooks/useResponsive';
import { PremiumAdsWithInfiniteScroll } from '@/components/AdsWithInfiniteScroll/PremiumAdsWithInfiniteScroll';
import { PopularRequests } from '@/components/PopularRequests';
import { useBannerStore } from '@/store/useBannerStore/useBannerStore';

export const HomeView = () => {
  const { isAndroid } = useMobileDetect();
  const { isDesktop } = useResponsive();
  const { topBanner, backgroundBanner } = useBanner({ isDesktop });
  const canLoadBanners = useBannerStore(state => state.canLoadBanners);
  const [hasNextPage, setHasNextPage] = useState(true);

  const handlePaginationChange = useCallback((nextPageExists: boolean) => {
    setHasNextPage(nextPageExists);
  }, []);

  return (
    <>
      {isAndroid && canLoadBanners && <AndroidAppBanner />}

      {canLoadBanners && topBanner}
      {backgroundBanner}

      <PageTopControls>
        <Header isMain />
        {!isDesktop && (
          <>
            <SearchPanel hideOnDesktop />
            <CatalogueGrid />
          </>
        )}
      </PageTopControls>

      <S.Wrapper>
        {isDesktop && <CatalogueGrid />}

        <PremiumAdsWithInfiniteScroll
          onPaginationChange={handlePaginationChange}
        />

        <S.PopularRequestsBox $isVisibile={!hasNextPage}>
          <PopularRequests />
        </S.PopularRequestsBox>

        {isDesktop ? (
          <S.DesktopFooter $isVisible={!hasNextPage} />
        ) : (
          <S.MobileFooter $isVisible={!hasNextPage} />
        )}
        {!isDesktop && <TabBar />}
      </S.Wrapper>
    </>
  );
};
